<ng-container *ngFor="let client of clients">
  <a
    *ngIf="client.canOpen; else readonlyClient"
    (click)="rowClick.emit()"
    routerLink="/clients/{{ client.id }}"
    class="row striped-row list py-1"
  >
    <search-client-row [item]="client" />
  </a>
  <ng-template #readonlyClient>
    <div class="row striped-row py-1">
      <search-client-row [item]="client" />
    </div>
  </ng-template>
</ng-container>
